import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// CSS
import "./home-hero.css";

const heroSlides = [
  {
    img: "https://images.pexels.com/photos/64208/pexels-photo-64208.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    headline: "Late-Night Hunger Fix!",
    subheadline: "Tasty meals delivered even after hours.",
    primaryBtn: "Late-Night Menu",
    category: "late_night",
  },
  {
    img: "https://images.pexels.com/photos/2673353/pexels-photo-2673353.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    headline: "Satisfy Your Evening Cravings!",
    subheadline: "Indulge in our mouthwatering dinner options.",
    primaryBtn: "Dinner Menu",
    category: "dinner",
  },
  {
    img: "https://images.pexels.com/photos/70497/pexels-photo-70497.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    headline: "Midday Hunger? We Got You Covered!",
    subheadline: "Enjoy a fulfilling lunch packed with flavor and freshness.",
    primaryBtn: "Lunch Menu",
    category: "lunch",
  },
  {
    img: require("../../assets/images/img-3.jpg"),
    headline: "Hungry? Get Delicious Food Delivered Fast!",
    subheadline: "Order Now & Enjoy Mouth-Watering Dishes Without the Wait!",
    primaryBtn: "Browse Menu",
    category: "All",
  },
  {
    img: "https://images.pexels.com/photos/376464/pexels-photo-376464.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    headline: "Rise and Shine with a Hearty Breakfast!",
    subheadline: "Start your day right with our delicious breakfast options",
    primaryBtn: "Breakfast Menu",
    category: "breakfast",
  },
  {
    img: "https://images.pexels.com/photos/1647163/pexels-photo-1647163.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    headline: "Perfect Snacks for Every Mood!",
    subheadline: "Crispy, crunchy, and delicious bites await you.",
    primaryBtn: "Snacks Menu",
    category: "snacks",
  },
  {
    img: "https://images.pexels.com/photos/2789328/pexels-photo-2789328.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    headline: "Refreshing Drinks for Any Occasion!",
    subheadline: "Quench your thirst with our refreshing beverages.",
    primaryBtn: "Drinks Menu",
    category: "drinks",
  },
  {
    img: "https://images.pexels.com/photos/8112951/pexels-photo-8112951.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    headline: "Bulk Orders Made Easy!",
    subheadline: "Pre-order in bulk for events and gatherings.",
    primaryBtn: "Pre-Order Menu",
    category: "pre_order",
  },
  {
    img: "https://images.pexels.com/photos/674574/pexels-photo-674574.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    headline: "Catering for Your Special Events!",
    subheadline: "Delicious lunch catering for offices and occasions.",
    primaryBtn: "Catering Menu",
    category: "catering",
  },
];

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 800,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: false,
  pauseOnHover: true,
  ltr: true,
};

const HomeHero = () => {
  return (
    <section className="home-hero">
      <Slider {...sliderSettings} className="home-hero-slider">
        {heroSlides.map((slide, index) => (
          <div key={index} className="home-hero-slide">
            <div className="home-hero-container">
              <div
                className="home-hero-img-container"
                style={{ backgroundImage: `url(${slide.img})` }}
              ></div>
              <div className="home-hero-text-container">
                <h1
                  className="uppercase
                          text-gray-900
                            font-[900]
                            tracking-widest
                            leading-tight
                            text-2xl
                            lg:text-3xl
                            2xl:text-4xl
                            mb-0
                            sm:mb-3
                            lg:mb-4
                            2xl:mb-5"
                >
                  Home delivery all day and night at Bashundhara
                </h1>
                <h1
                  className="
                            pb-2
                            text-gray-700
                            font-[900]
                            tracking-wider
                            leading-tight
                            text-2xl
                            lg:text-3xl
                            2xl:text-4xl"
                >
                  বসুন্ধরায় সারা দিন এবং রাতে হোম ডেলিভারি দেওয়া হয়
                </h1>
                <h1 className="home-hero-headline">{slide.headline}</h1>
                <h2 className="home-hero-subheadline">{slide.subheadline}</h2>
                <div className="home-hero-cta">
                  {slide.category === "All" ? (
                    <>
                      <Link to="/menu" className="btn btn-primary">
                        {slide.primaryBtn}
                      </Link>
                      <a href="tel:+880123456789" className="btn btn-secondary">
                        Call to Order
                      </a>
                    </>
                  ) : (
                    <>
                      <Link
                        to={`/menu?category=${encodeURIComponent(
                          slide.category
                        )}#full-menu`}
                        className="btn btn-primary"
                      >
                        {slide.primaryBtn}
                      </Link>
                      <Link to="/menu" className="btn btn-secondary">
                        Browse Menu
                      </Link>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default HomeHero;
